// ======================================================================
// File Name       : MessageThreadAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../utils/ApiUtils';
import { hideLoading } from '../utils/PageUtils';
import * as messageThreadRequest from './httpRequests/messageThread';
import * as groupRequests from './httpRequests/group';
import * as userRequest from './httpRequests/user';
import * as messageThreadActionCreators from './actionCreators/messageThread/messageThread';
import { downloadFile } from '../utils/index';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM } from '../constants';
import * as userActionTypes from '../constants/actionTypes/user';
import { USER_TYPE } from '../constants/UserConstants';
import { MESSAGE_TYPE, MESSAGE_FILTER } from '../constants/MessageThreadContants';
import * as ActionTypes from '../constants/actionTypes/messageThread';
import * as userAction from '../actions/UserAction';

export function getReceivedMessageList(param) {
  return async (dispatch, getState) => {
    const userListToSearch = [];
    const userListToStore = [];
    let messageList = [];
    const { storedUsers } = getState().messageThread;
    const messageListRes = await messageThreadRequest.getMessageList(param);
    if (messageListRes && messageListRes.messageList && messageListRes.messageList.length) {
      messageList = messageListRes.messageList;
    }
    return dispatch(
      messageThreadActionCreators.receiveMessageList(messageListRes, userListToStore),
    );
  };
}

export function getSentMessageList(param) {
  return dispatch =>
    messageThreadRequest.getMessageList(param).then((resData) => {
      const userListToStore = [];
      return dispatch(messageThreadActionCreators.receiveMessageList(resData, userListToStore));
    });
}

export function downloadMessageAttachment(param) {
  return dispatch =>
    messageThreadRequest.downloadMessageAttachment(param).then((resData) => {
      if (resData && resData.attachmentFileDownloadUrl) {
        const url = resData.attachmentFileDownloadUrl;
        downloadFile(url);
      }
    });
}

export function getMessageThreadDetail(param) {
  return async (dispatch, getState) => {
    const messageRes = await messageThreadRequest.getMessageList(param);
    let messageInfo = {};
    let userListToStore = [];
    let groupRelationList = [];
    let groupList = [];
    let userListToSearch = [];
    let rootMessageRelationList = [];
    let userListRecordNum = 0;
    if (messageRes.messageList && messageRes.messageList.length) {
      messageInfo = messageRes.messageList[0];
      let messageIdAuto = messageInfo.messageIdAuto;
      if (messageInfo && messageInfo.rootMessageIdAuto) {
        messageIdAuto = messageInfo.rootMessageIdAuto;
      }
      const searchMessageInfo = {
        rootMessageList: [messageIdAuto],
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
      };
      const relationRes = await messageThreadRequest.getMessageThreadUserRelation({
        searchInfo: searchMessageInfo,
      });
      if (relationRes && relationRes.rootMessageRelationList) {
        rootMessageRelationList = relationRes.rootMessageRelationList;
        userListRecordNum = relationRes.recordNum || 0;
      }
      const userList = rootMessageRelationList.reduce((acc, cur) => {
        if (cur.userSecernId) {
          acc.push(cur.userSecernId);
        }
        return acc;
      }, []);
      if (userList && userList.length) {
        const searchUserInfo = {
          userSecernIdList: userList,
        };
        userListToSearch = await userRequest.postUserGetList({ searchInfo: searchUserInfo });
      }
      if (userListToSearch && userListToSearch.userList && userListToSearch.userList.length) {
        userListToStore = userListToSearch.userList;
        const userSecernIdList = userListToSearch.userList.reduce((acc, cur) => {
          if (cur.userSecernId) {
            acc.push(cur.userSecernId);
          }
          return acc;
        }, []);
        const searchGroupRelationInfo = { userList: userSecernIdList };
        const groupRelationRes = await groupRequests.postUserGroupRelationGetList({
          searchInfo: searchGroupRelationInfo,
        });
        if (groupRelationRes && groupRelationRes.groupRelationList) {
          groupRelationList = groupRelationRes.groupRelationList;
        }
      }
      if (groupRelationList && groupRelationList.length) {
        const groupRes = await groupRequests.postGroupGetStructure(undefined, true);
        if (groupRes && groupRes.groupList) {
          groupList = groupRes.groupList;
        }
      }
    }
    return dispatch(
      messageThreadActionCreators.receiveMessageInfo(
        messageInfo,
        rootMessageRelationList,
        userListToStore,
        groupRelationList,
        groupList,
        userListRecordNum,
      ),
    );
  };
}

export function getMessageThreadUserRelation(searchUserRelationInfo) {
  return async (dispatch, getState) => {
    let rootMessageRelationList = [];
    let userListToSearch = [];
    let userListToStore = [];
    let groupRelationList = [];
    let userListRecordNum = 0;
    const relationRes = await messageThreadRequest.getMessageThreadUserRelation({
      searchInfo: searchUserRelationInfo,
    });
    if (relationRes && relationRes.rootMessageRelationList) {
      rootMessageRelationList = relationRes.rootMessageRelationList;
      userListRecordNum = relationRes.recordNum;
    }
    const userList = rootMessageRelationList.reduce((acc, cur) => {
      if (cur.userSecernId) {
        acc.push(cur.userSecernId);
      }
      return acc;
    }, []);
    if (userList && userList.length) {
      const searchUserInfo = {
        user_secern_id_list: userList,
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
      };
      userListToSearch = await userRequest.postUserGetList({ searchInfo: searchUserInfo });
    }
    if (userListToSearch && userListToSearch.userList && userListToSearch.userList.length) {
      userListToStore = userListToSearch.userList;
      const userSecernIdList = userListToSearch.userList.reduce((acc, cur) => {
        if (cur.userSecernId) {
          acc.push(cur.userSecernId);
        }
        return acc;
      }, []);
      const searchGroupRelationInfo = { userList: userSecernIdList };
      const groupRelationRes = await groupRequests.postUserGroupRelationGetList({
        searchInfo: searchGroupRelationInfo,
      });
      if (groupRelationRes && groupRelationRes.groupRelationList) {
        groupRelationList = groupRelationRes.groupRelationList;
      }
    }
    return dispatch(
      messageThreadActionCreators.receiveMessageThreadUserPaging(
        rootMessageRelationList,
        userListToStore,
        groupRelationList,
        userListRecordNum,
      ),
    );
  };
}

export function registerEditMessageThread(param) {
  return (dispatch) => {
    const paramMessage = {};
    paramMessage.editType = param.editType;
    paramMessage.messageInfo = param.messageInfo;
    param.attachmentFile && (paramMessage.attachmentFile = param.attachmentFile);
    return messageThreadRequest.registerEditMessageThread(paramMessage).then((resData) => {
      if (resData && resData.messageIdAuto) {
        if (!param.edittingUserList || !Object.keys(param.edittingUserList).length) {
          return {};
        }
        const paramRelation = {};
        paramRelation.editType = param.editType;
        paramRelation.rootMessageInfo = {
          rootMessageIdAuto: resData.messageIdAuto,
          userList: Object.keys(param.edittingUserList),
        };
        return dispatch(addMessageUserRelation(paramRelation));
      }
      return {};
    });
  };
}

export function initDataForDialog(searchUserInfo) {
  return async (dispatch, getState) => {
    let groupList = [];
    let userSearchResult = { recordNum: 0, userList: [] };
    let groupRelationList = [];
    await dispatch(userAction.getGroupListAll()).then((result) => {
      if (result && result.data && result.data.groupList) {
        groupList = result.data.groupList;
      }
    });
    userSearchResult = await fetchUser(searchUserInfo);
    if (userSearchResult && userSearchResult.userList && userSearchResult.userList.length) {
      const searchInfo = {};
      searchInfo.userList = userSearchResult.userList.reduce((acc, cur) => {
        if (cur.userSecernId) {
          acc.push(cur.userSecernId);
        }
        return acc;
      }, []);

      if (searchInfo.userList && searchInfo.userList.length) {
        const groupRelationListRes = await groupRequests.postUserGroupRelationGetList(searchInfo);
        if (groupRelationListRes && groupRelationListRes.groupRelationList) {
          groupRelationList = groupRelationListRes.groupRelationList;
        }
      }
    }
    return dispatch(
      messageThreadActionCreators.storeUserList(userSearchResult, groupRelationList, groupList),
    );
  };
}

export function searchUserOnDialog(param) {
  return async (dispatch, getState) => {
    let userSearchResult = {};
    let groupRelationList = [];
    const userSearchRes = await fetchUser(param);
    if (userSearchRes && userSearchRes.userList && userSearchRes.userList.length) {
      userSearchResult = userSearchRes;
      const searchInfo = {};
      const storedGroupRelationList = getState().messageThread.groupRelationList;
      if (storedGroupRelationList && storedGroupRelationList.length) {
        const userList = userSearchResult.userList;
        const userListToSearch = userList.reduce((acc, cur) => {
          if (cur.userSecernId) {
            const storedGroupRelations = storedGroupRelationList.filter(
              item => item.userSecernId === cur.userSecernId,
            );
            if (!storedGroupRelations || !storedGroupRelations.length) {
              acc.push(cur.userSecernId);
            }
          }
          return acc;
        }, []);
        searchInfo.userList = userListToSearch;
      }
      if (searchInfo.userList && searchInfo.userList.length) {
        const groupRelationRes = await groupRequests.postUserGroupRelationGetList(searchInfo);
        if (
          groupRelationRes &&
          groupRelationRes.groupRelationList &&
          groupRelationRes.groupRelationList.length
        ) {
          groupRelationList = groupRelationRes.groupRelationList;
        }
      }
    }
    return dispatch(
      messageThreadActionCreators.storeUserSearchResult(userSearchResult, groupRelationList),
    );
  };
}

function fetchUser(searchInfo = {}) {
  return userRequest.postUserGetList({
    selectTargetData: SELECT_TARGET_DATA.DATA,
    searchInfo,
  });
}

export function addUsersToList(userListToAdd) {
  return async (dispatch) => {
    await dispatch(messageThreadActionCreators.addUsersToList(userListToAdd));
    return {};
  };
}

export function removeUserFromList(userSecernId) {
  return dispatch => dispatch(messageThreadActionCreators.removeUserFromList(userSecernId));
}

export function addMessageUserRelation(param) {
  return dispatch => messageThreadRequest.registerEditUserRelation(param);
}

export function resetEdittingUsers() {
  return dispatch => dispatch(messageThreadActionCreators.resetEdittingUsers());
}

export function deleteMessageThread(param) {
  return async (dispatch) => {
    try {
      const deleteMessageRes = await messageThreadRequest.registerEditMessageThread({
        ...param.paramMessageInfo,
      });
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function getInitDataForChat(param) {
  return async (dispatch) => {
    let rootMessageInfo = {};
    const paramRootMessage = {};
    paramRootMessage.messageType = MESSAGE_TYPE.ROUTE;
    paramRootMessage.searchInfo = { messageList: [param.targetRootMessageIdAuto] };
    const rootMessageRes = await messageThreadRequest.getMessageList(paramRootMessage);
    if (rootMessageRes && rootMessageRes.messageList && rootMessageRes.messageList.length) {
      rootMessageInfo = rootMessageRes.messageList[0];
    }
    const structure = await messageThreadRequest.getMessageStructure(param);
    return dispatch(messageThreadActionCreators.receiveInitDataForChat(structure, rootMessageInfo));
  };
}

export function sendMessage(param, rootMessageIdAuto, userSecernId) {
  return async (dispatch) => {
    const paramMessage = {};
    paramMessage.editType = param.editType;
    paramMessage.messageInfo = param.messageInfo;
    param.attachmentFile && (paramMessage.attachmentFile = param.attachmentFile);
    const sendMessageRes = await messageThreadRequest.registerEditMessageThread(paramMessage);
    const paramStructure = {
      targetRootMessageIdAuto: rootMessageIdAuto,
      userSecernId,
      recursiveType: 1,
    };
    const structure = await messageThreadRequest.getMessageStructure(paramStructure);
    return dispatch(messageThreadActionCreators.receiveMessageStructure(structure));
  };
}

export function getMessageStructure(param) {
  return async (dispatch) => {
    const structure = await messageThreadRequest.getMessageStructure(param);
    return dispatch(messageThreadActionCreators.receiveMessageStructure(structure));
  };
}

export function loadMoreMessage() {
  return async (dispatch) => {
    const res = await dispatch(messageThreadActionCreators.loadMoreMessage());
    return {};
  };
}

export function reloadChatAfterDelete(messageInfo) {
  return async (dispatch) => {
    const res = await dispatch(messageThreadActionCreators.reloadChatAfterDelete(messageInfo));
    return {};
  };
}

export function removedUserOnDialog() {
  return {
    type: ActionTypes.REMOVED_USER_IN_DIALOG,
  };
}

export function removeAllUserFromList() {
  return {
    type: ActionTypes.REMOVE_ALL_USER_FROM_LIST,
  };
}

// Step 10.0.0 START
export function resetData() {
  return {
    type: ActionTypes.MESSAGE_THREAD_RESET_DATA,
  };
}
// Step 10.0.0 END
